import React from 'react';

export default function PageLoader() {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-95 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="flex flex-col items-center">
        {/* Spinner más sutil */}
        <div className="relative">
          <div className="w-12 h-12 border-3 border-gray-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-12 h-12 border-3 border-transparent border-t-[#B49A56] rounded-full animate-spin"></div>
        </div>
        
        {/* Logo de Belu Tours más pequeño */}
        <div className="mt-3">
          <img 
            src={`${process.env.PUBLIC_URL}/assets/logo-belutours-header.webp`} 
            alt="Belu Tours" 
            className="w-8 h-8 opacity-80"
          />
        </div>
      </div>
    </div>
  );
}
